// extracted by mini-css-extract-plugin
export default {"headerDate":"Header_headerDate__19Jcw","logoWrapper":"Header_logoWrapper__Inuny","soldOutSplash":"Header_soldOutSplash__NlpWm"};